import { Drawer } from 'antd';
import { createVendorEvaluationAsync } from '../../modules/vendors';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getExpenseCommon } from '../../api/constlink';
import VendorEvaluationCreateComponent from '../../components/vendors/VendorEvaluationCreateComponent';
import Title from 'antd/lib/typography/Title';

interface VendorEvaluationCreateDrawerProps {
  visible: boolean;
  config: any;
  onClose: () => void;
}

function VendorEvaluationCreateDrawer({
  visible,
  config,
  onClose,
}: VendorEvaluationCreateDrawerProps) {
  const [expenseCommon, setExpenseCommon] = useState<any>();

  const dispatch = useDispatch();
  useEffect(() => {
    if (visible === false) return;
    (async () => {
      const _expenseCommon = await getExpenseCommon(config.enterpriseId);
      setExpenseCommon({ ..._expenseCommon });
      console.log('expenseCommon', _expenseCommon);
    })();
  }, [config, visible]);

  const onCreate = async (data: any) => {
    if (!expenseCommon) return;

    const selectedProject = expenseCommon.projectList.find(
      (project: any) => project.id === +data.projectId,
    );

    let comment = '';

    if (!selectedProject) {
      comment = data.comment;
    } else {
      comment = `${selectedProject.name} (${selectedProject.startDate} ~ ${selectedProject.endDate})\n`;
      comment += data.comment;
    }

    const _vendorEvaluation = {
      comment,
      score: +data.score,
    };

    dispatch(
      createVendorEvaluationAsync.request({
        enterpriseId: config.enterpriseId,
        vendorId: config.vendorId,
        vendorEvaluation: _vendorEvaluation,
      }),
    );

    onClose();
  };

  return (
    <>
      {
        <Drawer
          width={600}
          placement="right"
          closable={true}
          maskClosable={false}
          title={<Title level={4}>거래처 평가</Title>}
          onClose={onClose}
          open={visible}
        >
          {visible && expenseCommon && (
            <VendorEvaluationCreateComponent
              expenseCommon={expenseCommon}
              onCreate={onCreate}
              onCancel={onClose}
            />
          )}
        </Drawer>
      }
    </>
  );
}

export default VendorEvaluationCreateDrawer;
